import inject from '@rover/utilities/injector';
import Vue from 'vue';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import eventBus from '@rover/globals/eventBus';
import CollapsingCheckboxCollection from '../../../styleguide/components/CollapsingCheckboxCollection/index.vue';
import ServiceTypeSelector from '../../../styleguide/components/ServiceTypeSelector.vue';

const homeFilterSelector = 'js-provider-home-filter-category';

export default {
  initServiceSelectorDropdown(classSelector) {
    const query = this.model;
    const { serviceTypes } = this;
    return new Vue({
      el: classSelector,
      components: { ServiceTypeSelector },
      bb() {
        return {
          query,
        };
      },
      data() {
        return {
          serviceTypes,
        };
      },
    });
  },

  listenToServiceTypeChange() {
    this.model.on('change:service_type', this.onServiceTypeChange);
    this.onServiceTypeChange(this.model);
  },

  onServiceTypeChange({ attributes }) {
    const sType = Rover.serviceTypesJson.filter(st => st.slug === attributes.service_type)[0];
    if (!sType) return;
    const $providerHomeFilters = $(`.${homeFilterSelector}`);
    if (sType.location === 'provider_home') {
      $providerHomeFilters.show();
    } else {
      $providerHomeFilters.hide();
    }
  },

  initAdvancedFilters(classSelector) {
    const query = this.model;
    const filterCategories = this.filtersToCategories(this.filters);
    this.listenToServiceTypeChange();
    return new Vue({
      el: classSelector,
      components: { CollapsingCheckboxCollection },
      bb() {
        return {
          query,
        };
      },
      data() {
        return {
          filterCategories,
          selectedFiltersCount: 0,
        };
      },
      mounted() {
        this.selectedFiltersCount = this.$children[0].totalSelected;
        eventBus.$on('update:totalSelected', count => {
          this.selectedFiltersCount = count;
        });
      },
    });
  },

  filtersToCategories(filters) {
    // The search filters experiment (experiment_search_filters_20171019) requires that
    // the filter categories be different from the standard hierarchy in search/filters.py.
    // If this experiment is accepted, we will need to refactor the default filter category
    // hierarchy in that ticket.
    // See https://roverdotcom.atlassian.net/browse/DEV-16805
    const housingConditions = filters.advanced_sitter_info.subcategories.housing_conditions;
    const petsInHome = filters.advanced_sitter_info.subcategories.pets_in_the_home;
    const children = filters.advanced_sitter_info.subcategories.children_in_the_home;
    const addlServicesFilters = filters.advanced_services.filters_map;
    const orgFilters = filters.advanced_sitter_info.subcategories.organizations.filters_map;
    const agencies = inject('Rover.context.agenciesJson', []);
    const providerGroups = inject('Rover.context.providerGroupsJson', []);
    const showStaffFilters = inject('Rover.context.showStaffFilters', false);
    let categories = [
      {
        category: housingConditions.description,
        classes: homeFilterSelector,
        rowsVisibleWhenCollapsed: 2,
        checkboxes: [
          housingConditions.filters_map.has_house,
          housingConditions.filters_map.has_fenced_yard,
          housingConditions.filters_map.dogs_allowed_on_furniture,
          housingConditions.filters_map.dogs_allowed_on_bed,
          housingConditions.filters_map.non_smoking,
        ].map(this.filterToCheckbox),
      },
      {
        category: petsInHome.description,
        classes: homeFilterSelector,
        checkboxes: [
          petsInHome.filters_map.person_does_not_have_dogs,
          petsInHome.filters_map.no_cats,
          petsInHome.filters_map.accepts_only_one_client,
          petsInHome.filters_map.no_caged_pets,
        ].map(this.filterToCheckbox),
      },
      {
        category: children.description,
        classes: homeFilterSelector,
        rowsVisibleWhenCollapsed: 1,
        checkboxes: [
          filters.advanced_sitter_info.filters_map.has_no_children,
          children.filters_map.no_children_0_5,
          children.filters_map.no_children_6_12,
        ].map(this.filterToCheckbox),
      },
      {
        category: 'Additional services',
        rowsVisibleWhenCollapsed: 4,
        checkboxes: [
          addlServicesFilters.puppy,
          addlServicesFilters.cat_care,
          addlServicesFilters.bathing_grooming,
          housingConditions.filters_map.knows_first_aid,
        ].map(this.filterToCheckbox),
      },
      {
        category: 'Sitter memberships',
        rowsVisibleWhenCollapsed: 1,
        checkboxes: [
          addlServicesFilters.is_premier,
          orgFilters.apse,
          orgFilters.petsitusa,
          orgFilters.volunteer_donor,
        ].map(this.filterToCheckbox),
      },
    ];
    if (showStaffFilters) {
      categories = categories.concat([
        {
          supercategory: 'Staff only',
          category: '',
          checkboxes: [
            {
              attribute: 'search_score_debug',
              label: 'Search score popover',
            },
          ],
        },
        {
          category: 'Agencies',
          rowsVisibleWhenCollapsed: 4,
          checkboxes: agencies.map(a => ({
            bindValueToList: a.pk,
            attribute: 'agency',
            label: a.name,
          })),
        },
        {
          category: 'Provider groups',
          rowsVisibleWhenCollapsed: 4,
          checkboxes: providerGroups.map(pg => ({
            bindValueToList: pg.pk,
            attribute: 'provider_group',
            label: pg.name,
          })),
        },
        {
          category: 'More staff only',
          rowsVisibleWhenCollapsed: 4,
          checkboxes: filters.staff_only.filters.map(this.filterToCheckbox),
        },
      ]);
    }
    return categories;
  },

  filterToCheckbox({ field_name, help_text, tooltip }) {
    return {
      attribute: field_name,
      label: help_text,
      tooltip,
    };
  },
};



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_advanced_filters_mixin.js